import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import AppShell from './components/AppShell';
import SplashPage from './pages/SplashPage';
import LoginPage from './pages/LoginPage';
import AccountActivationPage from './pages/AccountActivationPage';
import ProductAccessPage from './pages/ProductAccessPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import DocumentsPage from './pages/DocumentsPage';
import CreatePage from './pages/CreatePage';
import LibraryPage from './pages/LibraryPage';
import AccountPage from './pages/AccountPage';

function RequireAuth({ children }: { children: React.ReactElement }) {
  const { isAuthenticated, isInitialized } = useAuth();
  const location = useLocation();
  if (!isInitialized) {
    return (
      <div className="center-col" style={{ minHeight: '100vh' }}>
        <span className="spinner" />
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}${location.hash}` }} />;
  }
  return children;
}

export default function App() {
  const { isAuthenticated } = useAuth();
  return (
    <Routes>
      <Route path="/" element={isAuthenticated ? <Navigate to="/documents" replace /> : <SplashPage />} />
      <Route path="/login" element={isAuthenticated ? <Navigate to="/documents" replace /> : <LoginPage />} />
      <Route path="/verify-email" element={<AccountActivationPage />} />
      <Route path="/product-access" element={<ProductAccessPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/create" element={<CreatePage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/account" element={<AccountPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/documents" replace />} />
    </Routes>
  );
}
